import { EventTypeEnum } from "shared/types";

import useAssetsSchema from "./assetsSchema";
import { useClaimsSchema } from "./claimsSchema";
import { useCustomRecordsSchema } from "./customRecordsSchema";
import { useFleetsSchema } from "./fleetsSchema";
import { useInspectionsSchema } from "./inspectionsSchema";
import useIssuesSchema from "./issuesSchema";
import useRepairLaborSchema from "./repairLaborSchema";
import useRepairPartsSchema from "./repairPartsSchema";
import useRepairsSchema from "./repairsSchema";
import useSensorReadingsSchema from "./sensorReadingsSchema";
import useSignalEventOccurrencesSchema from "./signalEventOccurrencesSchema";
import { UseSchema } from "./types";
import useVehiclesSchema from "./vehiclesSchema";
import useWorkOrdersSchema from "./workOrdersSchema";

// Call sites pick an entry by event type, so switching event type under a mounted
// component swaps which hook runs. That only stays legal while no schema hook allocates
// React hooks (`useContext`/`use()` allocate none) — otherwise the caller's hook order
// shifts and React throws. Read translations through the i18next instance (`i18n.t`)
// rather than `useTranslation()` anywhere in this graph.
export const USE_RESOURCE_SCHEMA_MAP: Record<
  EventTypeEnum,
  (accessorsToHide?: string[]) => UseSchema
> = {
  [EventTypeEnum.CLAIM]: (accessorsToHide) => useClaimsSchema(accessorsToHide),
  [EventTypeEnum.REPAIR]: (accessorsToHide) =>
    useRepairsSchema({ accessorsToHide: accessorsToHide || [] }),
  [EventTypeEnum.INSPECTION]: (accessorsToHide) =>
    useInspectionsSchema(accessorsToHide),
  [EventTypeEnum.SIGNAL_EVENT]: (accessorsToHide) =>
    useSignalEventOccurrencesSchema(accessorsToHide),
  [EventTypeEnum.SENSOR_READING]: (accessorsToHide) =>
    useSensorReadingsSchema(accessorsToHide),
  [EventTypeEnum.CUSTOM_RECORD]: (accessorsToHide) =>
    useCustomRecordsSchema(accessorsToHide),
  [EventTypeEnum.ISSUE]: () => useIssuesSchema(),
  [EventTypeEnum.WORK_ORDER]: (accessorsToHide) =>
    useWorkOrdersSchema({ accessorsToHide: accessorsToHide || [] }),
  [EventTypeEnum.VEHICLE]: (accessorsToHide) =>
    useVehiclesSchema(accessorsToHide),
  [EventTypeEnum.FLEET]: () => useFleetsSchema(),
  [EventTypeEnum.REPAIR_LABOR]: (accessorsToHide) =>
    useRepairLaborSchema(accessorsToHide),
  [EventTypeEnum.REPAIR_PARTS]: (accessorsToHide) =>
    useRepairPartsSchema(accessorsToHide),
  [EventTypeEnum.ASSET]: (accessorsToHide) => useAssetsSchema(accessorsToHide),
};
